import React from "react";

const Input = ({
  type = "text",
  placeholder,
  value,
  onChange,
  label,
  error,
  icon,
  className: classNameProp = "",
  ...props
}) => {
  return (
    <div className="w-full">
      {label && (
        <label className="mb-2 block text-sm font-medium text-[var(--text-primary)]">
          {label}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute left-4 top-1/2 -translate-y-1/2 transform text-[var(--text-secondary)]">
            {icon}
          </div>
        )}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          className={`w-full rounded-full bg-[var(--bg-card)] px-4 py-3 text-[var(--text-primary)] ${
            icon ? "pl-12" : ""
          } 
            border border-[var(--border-color)] focus:border-primary focus:outline-none 
            transition-all duration-300 placeholder:text-[var(--text-secondary)] ${classNameProp}`}
          {...props}
        />
      </div>
      {error && <p className="mt-2 text-sm text-red-400">{error}</p>}
    </div>
  );
};

export default Input;
